// extracted by mini-css-extract-plugin
export var label = "_ic-2";
export var slideContainer = "_ic-0";
export var slider = "_ic-1";